import { _ as __rest } from '../tslib.es6-17e0406b.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { memo } from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { colors, Tooltip, Avatar, Typography } from '@mui/material';
import 'moment';
import { getInitials } from '../utils/getInitials.js';

const PREFIX = 'StackAvatars';
const classes = {
    root: `${PREFIX}-root`,
    avatar: `${PREFIX}-avatar`,
    more: `${PREFIX}-more`,
};
const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {
        display: 'flex',
        paddingLeft: 20,
    },
    [`& .${classes.avatar}`]: {
        border: `3px solid ${theme.palette.background.default}`,
        marginLeft: -20,
        '&:hover': {
            zIndex: 2,
        },
    },
    [`& .${classes.more}`]: {
        backgroundColor: colors.red[600],
        color: colors.common.white,
    },
}));
const StackAvatars = memo((_a) => {
    var { avatars = [], limit = 3, className } = _a, rest = __rest(_a, ["avatars", "limit", "className"]);
    const avatarNodes = avatars.slice(0, limit).map(item => (jsx(Tooltip, Object.assign({ title: item.name }, { children: jsx(Avatar, Object.assign({ className: classes.avatar, src: item.avatar }, { children: getInitials(item.name) })) }), item.id)));
    if (avatars.length > limit) {
        avatarNodes.push(jsx(Avatar, Object.assign({ className: clsx(classes.avatar, classes.more) }, { children: jsxs(Typography, Object.assign({ color: "inherit", variant: "subtitle2" }, { children: ["+", avatars.length - limit] })) }), "limit-avatar"));
    }
    return (jsx(Root, Object.assign({ className: clsx(classes.root, className) }, rest, { children: avatarNodes })));
});

export { StackAvatars };
